var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9ad2257e2a9ecd1b2a69eea39cc4bc619638bd93"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"9ad2257e2a9ecd1b2a69eea39cc4bc619638bd93"};
      